// Module
var code = "<button js-toast js-toast-message=\"Toast Message\">Trigger Toast</button>";
// Exports
export default code;